import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/posts/')({
  component: () => (
    <div>
      <h1 style={{ marginBottom: '10px', color: '#333', fontSize: '1.5rem' }}>Posts Index Route</h1>
      <p style={{ color: '#666', fontSize: '14px' }}>
        부모 경로(/posts)에 정확히 매칭될 때 렌더링되는 기본 자식 라우트입니다.
      </p>
    </div>
  ),
});

